"use client";

import { Box } from "@chakra-ui/react";
import ForwardCancellationTable from "./ForwardCancellationTable/ForwardCancellationTable";

const ForwardCancellation = () => {
  return (
    <Box>
      <ForwardCancellationTable />
    </Box>
  );
};

export default ForwardCancellation;
